import { render, staticRenderFns } from "./CognitiveInfo.vue?vue&type=template&id=9137e7da&scoped=true"
import script from "./CognitiveInfo.vue?vue&type=script&lang=js"
export * from "./CognitiveInfo.vue?vue&type=script&lang=js"
import style0 from "./CognitiveInfo.scss?vue&type=style&index=0&id=9137e7da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9137e7da",
  null
  
)

export default component.exports